import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableCustomerQuotes extends Layout {
    sourceQuoteList: DataSource;
    tableQuotes: Table;
}
